import { useEffect, useState } from 'react';
import { PATH } from 'routes/routeConfig';
import { useNavigate } from 'react-router-dom';
import { useLatestContractStatus } from 'hooks/useLatestContractStatus';

export const useContractUpdateDialog = () => {
  const navigate = useNavigate();
  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const { isSigned } = useLatestContractStatus();

  const handleClickDialog = () => {
    setIsOpenDialog(false);
    navigate(PATH.ACCOUNT_CONTRACT_UPDATE);
  };
  const handleCloseDialog = () => {
    setIsOpenDialog(false);
  };

  useEffect(() => {
    setIsOpenDialog(!isSigned);
  }, [isSigned]);

  return { isOpenDialog, handleClickDialog, handleCloseDialog };
};
